import axios from "axios";

async function callApi(path, method, data = [], externalApi = false, showLoading = true) {
    return await axios.request({
        method: method,
        url: path,
        ...(data ? { data: data } : ""),
        externalApi: externalApi,
        showLoading: showLoading
    });
}

export default {
    callApi,
};
